import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $partnerEditProfile,
  partnerEditProfileMounted,
  setPartnerEditProfile,
  updatePartner,
} from './model'
import exp from 'constants'

export const usePartnerEditProfile = () => {
  let partnerEditProfile = useStore($partnerEditProfile)
  const loading = useStore(updatePartner.pending)

  React.useEffect(() => {
    partnerEditProfileMounted()
  }, [])

  return { partnerEditProfile, loading }
}
